import React, { useMemo, useCallback } from 'react';
import { ITotalPrice } from 'types';
import MultipleSelect from './components/MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './RestaurantsForComments.module.scss';

interface IRestaurantsForComments {
	setIDsRestaurant: (value: string[]) => void;
	IDSelectedCustomer: Nullable<string>;
	IDsSelectedRestaurant: string[];
	restaurantsToExclude: string[];
	totalPrices: ITotalPrice[];
	inputName: string;
	inputLabel: string;
}

const RestaurantsForComments: React.FC<IRestaurantsForComments> = ({
	setIDsRestaurant,
	IDsSelectedRestaurant,
	restaurantsToExclude,
	totalPrices,
	inputName,
	inputLabel,
}) => {
	const restaurants = useMemo(() => {
		return totalPrices
			.filter((restaurant) => !restaurantsToExclude.includes(restaurant.restaurantId))
			.map((restaurant) => ({
				id: restaurant.restaurantId,
				name: restaurant.restaurantName,
				status: restaurant.restaurantStatus,
			}));
	}, [totalPrices, restaurantsToExclude]);

	const handleRemove = useCallback(
		(id: string) => {
			const updatedSelectedItems = IDsSelectedRestaurant.filter((el) => el !== id);
			setIDsRestaurant(updatedSelectedItems);
		},
		[IDsSelectedRestaurant, setIDsRestaurant],
	);

	const restaurantsList = useMemo(() => {
		return IDsSelectedRestaurant.map((el) => {
			const label = restaurants?.find((item) => item.id === el)?.name || '';

			return (
				<SelectedItem key={el} className={style.selectedItem} label={label} onDelete={() => handleRemove(el)} />
			);
		});
	}, [IDsSelectedRestaurant, restaurants, handleRemove]);

	return (
		<div className={style.container} data-test={inputName}>
			<div className={style.field}>
				<MultipleSelect
					data={restaurants || []}
					setIDsRestaurant={setIDsRestaurant}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
					inputName={inputName}
					inputLabel={inputLabel}
				/>
			</div>
			<div className={style.groupsList}>{restaurantsList}</div>
		</div>
	);
};

export default React.memo(RestaurantsForComments);
